import sortBy from 'lodash/sortBy'

/**
 * Sorts CheckoutLineItem edges by their
 * merchandise ID to maintain their positions
 */
export default edges => {
  return sortBy(edges, ({ node }) => node.merchandise.id)
}
